var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.sprints,"label":_vm.label,"hide-details":"","single-line":"","clearable":""},model:{value:(_vm.localSprint),callback:function ($$v) {_vm.localSprint=$$v},expression:"localSprint"}})}
var staticRenderFns = []

export { render, staticRenderFns }